import { render, staticRenderFns } from "./LazyBag.vue?vue&type=template&id=682ebbf8&"
import script from "./LazyBag.vue?vue&type=script&lang=js&"
export * from "./LazyBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports